<template>
  <div>
    <div class="content">
     <div class="service_top">
      <div class="service_content">
        <h1><span>场景一</span>私募/团队的业务管理</h1>
        <div>
            随着期货机构管理的资金规模逐渐增大，多品种、多策略、多交易员交易的模式成为了机构的首选。TMS系统支持将多个产品户或多个资金账户的资金分配给不同的投资账户，交给不同的交易员完成交易。每个交易员独立交易、统计，互不影响，满足机构多交易员的交易需求。
        </div>
        <div>
           同时提供交易所、资金账号、投资账号、产品四大维度的风控功能，可建立从整体到局部、多层级的风控体系，保证交易安全。多角度的资产分析报告、持仓分析工具，提供超过百项的各类统计数据，几十种分析图表，帮助机构既能够从整体上把握交易方向、投资风险，也能根据每个交易员的交易情况，优化资金配置，构建最优投资组合。
        </div>
        <div>
            而且文华TMS还提供了丰富的前端软件可供选择，涵盖各类机构交易工具，下单任务管理器、网格交易运行池、算法交易、文件下单、套利交易、量化交易等功能满足机构各种交易需求。整个系统全部由文华财经独立开发，期货中台系统→交易管理系统→行情交易软件，各系统间实现无缝连接，保证系统稳定、安全。
        </div>
        <h1 style="margin-top:42px"><span>场景二</span>期货公司资管部门的业务管理</h1>
        <div>
            期货公司资管部、风险管理子公司相较于一般投资机构有着更为严格的合规要求和监管标准。TMS系统提供了自定义工作流和回溯记录等工具，通过自定义角色及工作流，实现了多级审批，交易数据、操作数据、终端数据全部永久保存，并支持导出功能，方便配合监管机构检查。
        </div>
        <div>
            同时提供了全方位、多层级的风控体系，涵盖扩展性交易规则、产品、交易通道、交易员、策略组等多层级风控模块，全面保证资金及交易安全。其中产品风控支持根据相关法律法规和产品发行要求添加产品风控指标，如杠杆率控制、双25%、持仓数量、保证金和持仓市值等。还提供了针对产品层级的净值、当日亏损、总资产和回撤等指标的控制，可制定的产品联合风控方案，为交易保驾护航。
        </div>
        <div>
           系统支持多种业务，包括期货、期权、股票期权、股票。针对投资经理或交易员提供了专业的下单面板，方便快捷地提交交易指令，可实时监控和管理操作，从而提高交易的效率并更好地控制风险。
        </div>
      </div>
     </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.content {
  background: url("../assets/img/changj_02.jpg") no-repeat top;
  width: 100%;
  min-height: 600px;
  padding-top: 214px;
  font-size: 14px;
  text-align: left;
}
.service_content {
  width: 1060px;
  margin: 0 auto;
  position: relative;
  top: -110px;
  background: #f6fbfe;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 0 20px -5px #ccc;
  min-height: 643px;
  padding-bottom: 50px;
}
.service_top{
    height:614px ;
    background: url("../assets/img/changj_03.jpg") no-repeat top center;
}
.service_content .title {
  color: #5f5f5f;
  border-bottom: 1px dashed #a8a8a8;
  line-height: 40px;
  font-size: 22px;
}
.text_content {
  text-indent: 2em;
  font-size: 14px;
  line-height: 20px;
  color: #6f6f6f;
  padding: 10px 0;
  text-align: justify;
}
.title2 {
  font-size: 16px;
  color: #5d0f0b;
  border-left: 4px solid #e24a49;
  font-weight: bold;
  padding-left: 10px;
  margin: 15px 0;
}
.content h1 {
    margin-top: 42px;
    margin-bottom: 25px;
    font-size: 15px;
    font-weight: 600;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}
.content h1 span {
    margin-right: 10px;
    color: rgb(34, 89, 167);
}
.flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}
.content .title {
    width: 80px;
}
.content .word {
    width: 1060px;
    text-align: justify;
}
.service_content div{
    line-height: 24px;
    text-indent: 2em;
}
</style>